export default {"src":"/_next/static/image/public/images/down_arrow_blue.896f2b6b6111639b0b197275806a87a2.svg","height":8,"width":15};